<template>
  <DefSlideLeft>
    <div v-if="active" class="blog-mobile-menu">
      <span class="blog-mobile-exit" @click="$emit('close')">
        <svg class="blog-mobile-exit__close"><use xlink:href="#svg-blog-close"></use></svg>
      </span>
      <BlogMenu />

      <hr class="blog-mobile-line" />

      <div class="blog-mobile-lang">
        <p class="blog-mobile-lang__title">{{ messages.lang }}:</p>
        <BlogLang />
      </div>

      <hr class="blog-mobile-line" />
      <BlogGoToSite />
    </div>
  </DefSlideLeft>
</template>

<script lang="ts" setup>
import DefSlideLeft from '@components/Def/DefAnimations/DefSlideLeft.vue';
import BlogMenu from '@components/Blog/Header/BlogMenu.vue';
import BlogLang from '@components/Blog/Header/BlogLang.vue';
import BlogGoToSite from '@components/Blog/Header/BlogGoToSite.vue';
import { useResultsStore } from '@/storePinia/stores/results';
import { computed } from 'vue';

const props = defineProps(['active']);

const resultsStore = useResultsStore();

const messages = computed(() => resultsStore?.siteLanguages?.messages);
</script>

<style lang="scss" scoped>
.blog-mobile-menu {
  position: fixed;
  z-index: 1001;
  top: 0;
  bottom: 0;
  left: 0;
  width: 280px;
  background-color: #fff;
  padding: 36px 16px;
}
.blog-mobile-exit {
  position: absolute;
  top: 16px;
  right: 16px;
  &__close {
    display: block;
    width: 24px;
    height: 24px;
  }
}
.blog-mobile-line {
  margin: 24px 0;
  border: unset;
  height: 1px;
  background-color: var(--border-grey);
}
.blog-mobile-lang {
  display: flex;
  align-items: center;
  &__title {
    font-weight: 500;
    font-size: rem(14);
    line-height: 125%;
    color: #5f5f67;
    margin-right: 20px;
  }
}
</style>
